import React from "react";
import { Select as AntdSelect } from "antd";
import type { SelectProps } from "antd";

const optionLabel = (option: any): string => {
  const value = option?.label ?? option?.children ?? option?.value ?? "";
  return React.Children.toArray(value)
    .map((child: any) => (typeof child === "string" || typeof child === "number" ? child : ""))
    .join("");
};

const compareOptions = (first: any, second: any) =>
  optionLabel(first).localeCompare(optionLabel(second), undefined, {
    sensitivity: "base",
  });

const optionSearchText = (option: any) =>
  `${optionLabel(option)} ${option?.value ?? ""}`.toLowerCase();

/**
 * Keeps Ant Design Select's API intact while making application dropdowns
 * searchable and consistently ordered by their displayed text.
 */
const SearchableSelect = React.forwardRef<any, SelectProps<any>>(({ children, options, ...props }, ref) => {
  const sortedOptions = Array.isArray(options) ? [...options].sort(compareOptions) : options;
  const sortedChildren = React.Children.toArray(children).sort(compareOptions);

  return (
    <AntdSelect
      {...props}
      ref={ref}
      showSearch
      optionFilterProp="label"
      filterOption={(input, option) =>
        optionSearchText(option).includes(String(input).toLowerCase())
      }
      filterSort={compareOptions}
      options={sortedOptions}
    >
      {sortedChildren}
    </AntdSelect>
  );
});

SearchableSelect.displayName = "SearchableSelect";

export default Object.assign(SearchableSelect, {
  Option: AntdSelect.Option,
  OptGroup: AntdSelect.OptGroup,
});
